<script setup lang="ts">
import type { TutorBillingTriStateOption } from '../model/interfaces'
import type { TriState } from '../model/types'

import { AppSwitcherItem, AppSwitcherList } from '@shared/ui/switchers'

defineOptions({
  name: 'TutorBillingTriStateSwitcher',
})

defineProps<{
  value: TriState
  options: TutorBillingTriStateOption[]
  label: string
}>()

const emit = defineEmits<{
  change: [value: TriState]
}>()
</script>

<template>
  <AppSwitcherList
    class="tutor-billing-tri-state-switcher"
    role="group"
    :aria-label="label"
  >
    <AppSwitcherItem
      v-for="option in options"
      :key="option.text"
      :class="['tutor-billing-tri-state-switcher__option', `tutor-billing-tri-state-switcher__option--${option.tone}`]"
      :text="option.text"
      :selected="value === option.value"
      @click="emit('change', option.value)"
    />
  </AppSwitcherList>
</template>

<style scoped lang="scss" src="./TutorBillingTriStateSwitcher.scss" />
